var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Subject } from '@/models/Subject';
import { isEqual } from 'lodash';
import SubjectSelect from '@/components/SubjectSelect/SubjectSelect';
let TopicFilter = class TopicFilter extends Vue {
    constructor() {
        super(...arguments);
        this.isLoading = false;
        this.topics = [];
    }
    mounted() {
        if (this.area) {
            this.fetchTopics();
        }
    }
    async fetchTopics() {
        this.isLoading = true;
        const area = await new Subject()
            .include(['children'])
            .find(this.area);
        if (area && area.children) {
            this.topics = area.children;
        }
        this.isLoading = false;
    }
    async onInput(value) {
        if (isEqual(this.value, value)) {
            return;
        }
        this.$emit('input', value);
    }
    areaChanged() {
        if (this.area) {
            this.fetchTopics();
        }
        else {
            this.topics = [];
            this.$emit('input', null);
        }
    }
};
__decorate([
    Prop({ default: null }),
    __metadata("design:type", String)
], TopicFilter.prototype, "value", void 0);
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], TopicFilter.prototype, "area", void 0);
__decorate([
    Watch('area'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TopicFilter.prototype, "areaChanged", null);
TopicFilter = __decorate([
    Component({
        components: {
            SubjectSelect,
        },
    })
], TopicFilter);
export default TopicFilter;
